// extracted by mini-css-extract-plugin
export default {"root":"Vni2pYMVFQ"};